import { motion } from "framer-motion";
import { RecipientTemplates } from "@/components/account/RecipientTemplates";
import { ImportExportBar } from "@/components/customers/ImportExportBar";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";

const Customers = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    // Function to refresh templates data after import
    const refreshTemplates = () => {
        queryClient.invalidateQueries({ queryKey: ["recipient-templates"] });
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.3 }}
            className="container mx-auto px-4 py-8"
        >
            <div className="flex flex-col space-y-8">
                <div className="flex items-center justify-between">
                    <h1 className="text-3xl font-bold text-[#34375B]">
                        {t("customers.title", "Customers")}
                    </h1>

                    {/* Add ImportExportBar component */}
                    <div className="flex gap-2">
                        <ImportExportBar
                            templates={[]} // This will be fetched in RecipientTemplates and passed through a context
                            onImportComplete={refreshTemplates}
                            t={t}
                        />
                    </div>
                </div>
                <RecipientTemplates />
            </div>
        </motion.div>
    );
};

export default Customers; 